<template>
  <component :is="tag" :class="['card', `card--${elevation}`]" :to="to">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    tag: { type: String, default: 'div' }, // div | router-link | a
    elevation: { type: String, default: 'flat' }, // flat | raised | hover
    to: { type: [String, Object], default: '' }
  }
}
</script>

<style scoped>
.card {
  background: var(--bg-surface);
  border: var(--border-width-default) var(--border-style-base) var(--border-default);
  border-radius: var(--radius-xl);
  text-decoration: none;
  color: inherit;
  overflow: hidden;
}

/* Elevation */
.card--flat { box-shadow: var(--shadow-xs); }
.card--raised { box-shadow: var(--shadow-md); }
.card--hover {
  box-shadow: var(--shadow-xs);
  transition: transform var(--duration-medium) var(--ease-base),
              box-shadow var(--duration-medium) var(--ease-base),
              border-color var(--duration-medium) var(--ease-base);
}
.card--hover:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-xl);
  border-color: var(--primary);
}
</style>
